import React from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';
import { Link } from 'react-router-dom';

const avatar1 = 'https://placehold.co/100x100?text=ZP'; // Placeholder for profile avatar
const profileImg = 'https://placehold.co/300x200?text=Pharmacy+Banner'; // Placeholder for banner image

const WelcomeComp: React.FC = () => {
  return (
    <Card className="overflow-hidden shadow-sm border-0">
      <div className="bg-light p-3 border-bottom">
        <Row>
          <Col xs={8}>
            <div>
              <h5 className="text-success fw-bold mb-1">Welcome Back to Zohab Pharmacy</h5>
              <p className="mb-0 text-muted">Your trusted pharmacy dashboard</p>
            </div>
          </Col>
          <Col xs={4} className="text-end">
            <img src={profileImg} alt="Pharmacy banner" className="img-fluid rounded" />
          </Col>
        </Row>
      </div>

      <CardBody className="pt-0">
        <Row className="align-items-center">
          <Col sm={4} className="text-center mt-4">
            <div className="avatar-md profile-user-wid">
              <img src={avatar1} alt="Pharmacist Avatar" className="img-thumbnail rounded-circle" />
            </div>
            <h5 className="mt-3 mb-1 fw-semibold">Dr. Zohab Hassan</h5>
            <p className="text-muted mb-0">Chief Pharmacist</p>
          </Col>

          <Col sm={8}>
            <Row className="pt-4">
              <Col xs={6} className="text-center">
                <h5 className="fw-bold text-primary">420</h5>
                <p className="text-muted mb-0">Medicines in Stock</p>
              </Col>
              <Col xs={6} className="text-center">
                <h5 className="fw-bold text-primary">96</h5>
                <p className="text-muted mb-0">Sales Today</p>
              </Col>
            </Row>

            <div className="text-center mt-4">
              <Link to="/profile" className="btn btn-success btn-sm">
                View Profile <i className="mdi mdi-arrow-right ms-1"></i>
              </Link>
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default WelcomeComp;
